import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root'); // required for accessibility

const DisclaimerModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const hasAccepted = localStorage.getItem('disclaimerAccepted');
        if (!hasAccepted) {
            setIsOpen(true);
        }
    }, []);

    const handleAgree = () => {
        localStorage.setItem('disclaimerAccepted', 'true');
        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => { }}
            shouldCloseOnOverlayClick={false}
            contentLabel="Disclaimer"
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    zIndex: 1000
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)',
                    maxWidth: '600px',
                    padding: '30px',
                    borderRadius: '10px'
                }
            }}
        >
            <h2>Disclaimer</h2>
            <p>
                The information provided on this website is strictly for informational and entertainment purposes only.
                This website does not offer or promote any form of real-money gambling, betting, or wagering.
                We do not accept or facilitate any monetary transactions or bets, nor do we encourage participation in gambling activities.
                <br /><br />
                By continuing to use this site, you confirm that:
                <ul>
                    <li>You are at least 18 years old.</li>
                    <li>You understand that this site does not offer or promote gambling or betting.</li>
                    <li>You will not use the information herein for any unlawful purposes.</li>
                </ul>
            </p>
            <button onClick={handleAgree} style={buttonStyle}>I Agree</button>
        </Modal>
    );
};

const buttonStyle = {
    marginTop: '20px',
    padding: '10px 20px',
    background: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer'
};

export default DisclaimerModal;
